import { doAttention } from '@/attention';
export function shakeX(el, duration = undefined, options = {}) {
    return doAttention(el, 'shakeX', duration, options);
}
//# sourceMappingURL=shakeX.js.map